import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import TextFieldValidation from "../TextFieldValidation";
import ButtonExit from "../../../button/ButtonExit";
import ButtonAdd from "../../../button/ButtonAdd";

const normalizeVariableForm = (form) => ({
    name: String(form?.name ?? ""),
    pattern: String(form?.pattern ?? ""),
    comment: String(form?.comment ?? ""),
});

const ModalAddVariable = ({
                              initValue,
                              open,
                              onClose,
                              title,
                              handleSubmit,
                              labelButtonSubmit,
                              loading,
                          }) => {
    const [formState, setFormState] = useState(initValue)
    const [validationState, setValidationState] = useState(initValue)

    useEffect(() => {
        setFormState(initValue)
        setValidationState(Object.keys(initValue).reduce((acc, it) => ({...acc, [it]: ""}), {}))
    }, [initValue])

    const handleValidationData = () => {
        handleSubmit(normalizeVariableForm(formState))
    }

    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">{title}</DialogTitle>
            <DialogContent sx={{minWidth: 300}}>
                <TextFieldValidation
                    name={"name"}
                    label={"Наименование"}
                    value={formState?.name}
                    setCurrValues={setFormState}
                    validationError={validationState?.name}
                    setValidationState={setValidationState}
                    required={false}
                />
                <TextFieldValidation
                    name={"pattern"}
                    label={"Значение"}
                    value={formState?.pattern}
                    setCurrValues={setFormState}
                    validationError={validationState?.pattern}
                    setValidationState={setValidationState}
                    required={false}
                />
                <TextFieldValidation
                    name={"comment"}
                    label={"Комментарий"}
                    value={formState?.comment}
                    setCurrValues={setFormState}
                    validationError={validationState?.comment}
                    setValidationState={setValidationState}
                    required={false}
                />
            </DialogContent>

            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Выйти"} onClick={onClose}/>
                <ButtonAdd
                    loading={loading}
                    text={labelButtonSubmit}
                    onClick={handleValidationData}
                />
            </DialogActions>
        </Dialog>
    );
}
export default ModalAddVariable
